import ApiService from '../amplify/APIService';
import { push_notification } from './fetchActions';
import { NotificationType } from "../firebase/notifications/constant";

export const PAYMENT_PENDING_LOADING_ACTION = 'PAYMENT_PENDING_LOADING_ACTION';
export const PAYMENT_PENDING_LOADED_ACTION = 'PAYMENT_PENDING_LOADED_ACTION';
export const PAYMENT_PENDING_LOAD_FAILED_ACTION = 'PAYMENT_PENDING_LOAD_FAILED_ACTION';

const paymentPendingLoading = () => ({ type: PAYMENT_PENDING_LOADING_ACTION });
const paymentPendingLoaded = data => ({ type: PAYMENT_PENDING_LOADED_ACTION, data });
const paymentPendingFailed = error => ({ type: PAYMENT_PENDING_LOAD_FAILED_ACTION, error });

export function loadPaymentPending() {
    return async (dispatch) => {
        dispatch(paymentPendingLoading());
        let { ok, data } = await ApiService.getAppointmentToPay();
        if (ok) {
            if (data.founded) {
                dispatch(paymentPendingLoaded(data));
                dispatch(push_notification({
                    type: NotificationType.paymentOrderRequired,
                    title: 'Pending payment request',
                    body: 'Please complete the payment to finish the appointment. ',
                    notificationId: `${NotificationType.paymentOrderRequired}-${data.appointment_id}`
                }));
            } else {
                dispatch(paymentPendingLoaded({ founded: false }));
            }
        } else {
            dispatch(paymentPendingFailed());
        }
    };
}
